import { Drawer } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { setBottomSheetVisible, useCurrentChat } from '@guuru/chat-web';

const BottomSheet = function ({ children = null, ...rest }) {
  const { bottomSheetVisible } = useCurrentChat();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        setBottomSheetVisible(false);
      }
    });
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);

  return (
    <Drawer
      {...rest}
      open={bottomSheetVisible}
      onClose={() => setBottomSheetVisible(false)}
      destroyOnHidden
      placement="bottom"
      size="87%"
      styles={{
        header: {
          border: 'none',
          padding: 16,
        },
        section: {
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        },
      }}
    >
      {bottomSheetVisible && children}
    </Drawer>
  );
};

BottomSheet.propTypes = {
  children: PropTypes.node,
};

export default BottomSheet;
